import { motion } from "framer-motion";
import { Reveal } from "../components/Reveal";
import { ProcessTimeline } from "../components/ProcessTimeline";
import { CTASection } from "../components/CTASection";
import { SEO } from "../components/SEO";
import { IMAGES } from "../data/content";

export default function Process() {
  return (
    <div>
      <SEO
        title="Our Building Process | From Consultation to Handover | Kotam Projects"
        description="Kotam Projects' seven-stage building process — consultation, planning, quotation, construction, quality assurance, project completion and handover — delivering clarity and confidence across VIC & SA."
        path="/process"
      />
      <section className="relative pt-36 pb-20 sm:pt-44 sm:pb-28 overflow-hidden bg-forest-dark text-white">
        <div className="absolute inset-0 opacity-25">
          <img src={IMAGES.concreteDetail} alt="Construction craftsmanship detail on a Kotam Projects build" className="h-full w-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-forest-dark via-forest-dark/80 to-forest-dark/50" />
        <div className="container-px relative">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="label text-gold">
            Our Process
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }} className="mt-6 font-display font-light text-hero max-w-4xl">
            Seven stages. One standard.
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="mt-8 max-w-2xl text-lg sm:text-xl text-white/70 leading-relaxed">
            Our disciplined, transparent process keeps every project on track — from the first conversation
            to the moment we hand over the keys.
          </motion.p>
        </div>
      </section>

      <section className="container-px py-24 sm:py-32 lg:py-40">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <ProcessTimeline />
          </div>
          <div className="lg:col-span-5">
            <Reveal className="sticky top-28">
              <div className="overflow-hidden rounded-[24px]">
                <img src={IMAGES.blueprint1} alt="Planning on site" className="h-80 w-full object-cover" loading="lazy" />
              </div>
              <div className="mt-6 rounded-[24px] border border-border bg-concrete/40 p-8">
                <p className="label text-gold">Why it matters</p>
                <p className="mt-4 text-lg text-charcoal/60 leading-relaxed">
                  A structured process removes uncertainty. You always know what's happening, what's next, and
                  what it costs — so you can proceed with complete confidence.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
